import React from 'react';

// Enhanced EmptyState with friendly no-code explanations
// Blank pages are teaching moments, not empty spaces
const EmptyState = ({ onCreateApp }) => {
  return (
    <div className="empty-state">
      <div className="empty-state-content">
        {/* Icon */}
        <div className="empty-state-icon">
          📱
        </div>

        {/* Message */}
        <h2 className="empty-state-title">You haven't created any applications yet</h2>
        
        {/* Explanation (simple language for no-code users) */}
        <div className="empty-state-explanation">
          <p className="explanation-text">
            <strong>What are applications?</strong>
          </p>
          <p className="explanation-detail">
            Applications are your projects. Each application can have multiple pages, 
            data tables, integrations, and processes. Think of it as your workspace 
            where you build everything your users will interact with.
          </p>
          <p className="explanation-text">
            <strong>Why create one?</strong>
          </p>
          <p className="explanation-detail">
            Start by creating your first application to build beautiful pages, 
            manage data, and automate workflows—all without writing code!
          </p>
        </div>

        {/* Action Button */}
        <button onClick={onCreateApp} className="btn-empty-action">
          <span className="btn-icon">➕</span>
          Create Your First Application
        </button>

        {/* Features List - showing what you can do */}
        <div className="empty-state-features">
          <div className="feature-item">
            <span className="feature-icon">🎨</span>
            <div className="feature-content">
              <span className="feature-title">Visual Page Builder</span>
              <span className="feature-desc">Design screens your users will see</span>
            </div>
          </div>
          <div className="feature-item">
            <span className="feature-icon">📊</span>
            <div className="feature-content">
              <span className="feature-title">Data Management</span>
              <span className="feature-desc">Upload or manage data using files or tables</span>
            </div>
          </div>
          <div className="feature-item">
            <span className="feature-icon">🔄</span>
            <div className="feature-content">
              <span className="feature-title">Processes</span>
              <span className="feature-desc">Create step-by-step flows and automations</span>
            </div>
          </div>
          <div className="feature-item">
            <span className="feature-icon">🔌</span>
            <div className="feature-content">
              <span className="feature-title">Integrations</span>
              <span className="feature-desc">Connect with external tools and services</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;
